export type AccordionSectionTokens = {
	sectionGap: string;
	contentGap: string;
};

/** AccordionSection — only layout tokens (gaps); header/content visuals come from the Optimus accordion theme. */
export default {
	/** Gap between accordion panels when multiple in a grid (Figma: 32px). */
	sectionGap: '32px',
	/** Gap between projected children inside an AccordionSection's body wrapper. */
	contentGap: '24px',
} satisfies AccordionSectionTokens;
